import React, { useEffect, useRef, useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../App.css";
import "../fire.scss";
import { UserProvider } from "../context/userContext";

const tele = window.Telegram.WebApp;

const Home = () => {
  const location = useLocation();
  const scrollableEl = useRef(null);
  const touchStartY = useRef(null);

  // ... остальные обработчики остаются такими же ...

  // Инициализация Telegram WebApp
  useEffect(() => {
    // Простой градиент для максимальной производительности
    document.body.style.background = "#0a0a1a";
    tele.setBackgroundColor("#0a0a1a");
    tele.setHeaderColor("#0a0a1a");
    tele.ready();
    tele.expand();

    if (tele.HapticFeedback) {
      tele.HapticFeedback.impactOccurred("soft");
    }
  }, []);

  // ... остальной код обработчиков ...

  return (
    <UserProvider>
      <div className="relative w-full h-screen overflow-hidden">

        {/* Минимальный перформанс фон */}
        <div className="fixed inset-0 z-0 bg-gradient-to-b from-[#180749] to-[#1a1a2e]">
          {/* Легкие точки для текстуры */}
          <div className="absolute top-0 left-0 w-full h-full opacity-5">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <pattern id="dots" x="0" y="0" width="30" height="30" patternUnits="userSpaceOnUse">
                  <circle cx="2" cy="2" r="1" fill="#fff" />
                </pattern>
              </defs>
              <rect width="100%" height="100%" fill="url(#dots)" />
            </svg>
          </div>
          
          {/* Только один акцент для производительности */}
          <div className="absolute top-0 right-0 w-48 h-48 bg-purple-600/5 rounded-full blur-xl" />
        </div>

        {/* Контент */}
<div
  ref={scrollableEl}
  className="
    h-full
    w-full
    overflow-y-auto
    overscroll-y-contain
    relative
    z-10
  "
  style={{
    WebkitOverflowScrolling: "touch",
  }}
>

          <div className="w-full max-w-[720px] mx-auto px-0 pb-[140px]">

            <Outlet />

          </div>
        </div>
      </div>
    </UserProvider>
  );
};

export default Home;